module.exports = __webpack_public_path__ + "static/intro-836090694.2e2b6ce7.jpg";